import { fetchOrders } from './ordersApi';

const toExactDateTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return { date: '—', time: '—', text: '—' };
  const date = d.toLocaleDateString('en-GB').replace(/\//g, '.');
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return { date, time, text: `${date} ${time}` };
};

const toRelativeTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return '—';
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 10) return 'Just now';
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
};

const buildItemsSummary = (items) => {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return '';

  const parts = list
    .map((it) => {
      const name = (it?.item_name ?? it?.itemName ?? it?.product_name ?? it?.productName ?? '').toString().trim();
      if (!name) return null;
      const qty = Number(it?.quantity ?? 1);
      return qty > 1 ? `${name} ×${qty}` : name;
    })
    .filter(Boolean);

  if (!parts.length) return '';
  const max = 4;
  const shown = parts.slice(0, max);
  const remaining = parts.length - shown.length;
  return remaining > 0 ? `${shown.join(', ')} +${remaining} more` : shown.join(', ');
};

export const fetchOrderNotificationsFromOrders = async () => {
  const orders = await fetchOrders();

  // Latest first
  const sorted = (orders || []).slice().sort((a, b) => {
    const da = new Date(a.order_date || a.created_at || a.updated_at || 0);
    const db = new Date(b.order_date || b.created_at || b.updated_at || 0);
    return db - da;
  });

  return sorted.slice(0, 50).map((o) => {
    const orderId = String(o.id ?? o.order_id ?? '');
    const status = String(o.status ?? '').toLowerCase();
    const customerName = o.customer_name ?? o.customerName ?? o.customer ?? '';
    const createdAt = o.updated_at ?? o.order_date ?? o.created_at ?? null;
    const exact = toExactDateTime(createdAt);
    const itemsSummary = buildItemsSummary(o.items);
    const totalAmount = Number(o.total_amount ?? o.totalAmount);

    const isCancel = status === 'cancelled';
    return {
      id: `order-${orderId}-${status}-${createdAt || ''}`,
      type: 'order',
      title: isCancel ? `Order #${orderId} cancelled` : `New order #${orderId}`,
      message: isCancel
        ? `Order #${orderId} cancelled${customerName ? ` by ${customerName}` : ''}`
        : `New order #${orderId} received${customerName ? ` from ${customerName}` : ''}`,
      details: [
        customerName ? `Customer: ${customerName}` : null,
        itemsSummary ? `Items: ${itemsSummary}` : null,
        Number.isFinite(totalAmount) ? `Total: ₹${totalAmount}` : null,
        exact.text !== '—' ? `Placed: ${exact.text}` : null,
      ].filter(Boolean),
      time: toRelativeTime(createdAt),
      exactDate: exact.date,
      exactTime: exact.time,
      createdAt,
      raw: o,
    };
  });
};

